var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "121px",
    height: "109px",
    viewBox: "0 0 121 109",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Illustration document") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Journey-6---Users",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4.4--request-signature---send-request",
    transform: "translate(-698.000000, -308.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration-document",
    transform: "translate(699.000000, 308.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115,54.5 C115,84.5989875 90.5989875,109 60.5,109 C30.4010125,109 6,84.5989875 6,54.5 C6,24.4010125 30.4010125,0 60.5,0 C90.5989875,0 115,24.4010125 115,54.5",
    id: "Fill-1",
    fill: "#F4F6FC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 80.000000)",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L3,0",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,0 L119,0",
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,0 L113,0",
    id: "Stroke-3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23,93.4993412 C23,94.8801054 32.849441,96 45,96 C57.150559,96 67,94.8801054 67,93.4993412 C67,92.1185771 57.150559,91 45,91 C32.849441,91 23,92.1185771 23,93.4993412",
    id: "Fill-3",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,93 C55.1849802,93 52.0909091,89.8964427 52.0909091,86.0666667 L52.0909091,47.9333333 C52.0909091,44.1049275 48.9982034,41 45.1818182,41 L21,41 C24.8163852,41 27.9090909,44.1049275 27.9090909,47.9333333 L27.9090909,86.0666667 C27.9090909,89.8964427 31.0031621,93 34.8181818,93 L59,93 Z",
    id: "Fill-5",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,48.7365618 C28,45.0168081 24.8652174,42 20.9986166,42 C17.1333992,42 14,45.0168081 14,48.7365618 L14,56.4689632 C14,57.3143618 14.7124506,58 15.5909091,58 L28,58 L28,48.7365618 Z",
    id: "Fill-7",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,48.7365618 C28,45.0168081 24.8652174,42 20.9986166,42 C17.1333992,42 14,45.0168081 14,48.7365618 L14,56.4689632 C14,57.3143618 14.7124506,58 15.5909091,58 L28,58 L28,48.7365618 Z",
    id: "Stroke-9",
    stroke: "#7450C8",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,93 C55.1849802,93 52.0909091,89.8964427 52.0909091,86.0666667 L52.0909091,47.9333333 C52.0909091,44.1049275 48.9982034,41 45.1818182,41 L21,41 C24.8163852,41 27.9090909,44.1049275 27.9090909,47.9333333 L27.9090909,86.0666667 C27.9090909,89.8964427 31.0031621,93 34.8181818,93 L59,93 Z",
    id: "Stroke-11",
    stroke: "#7450C8",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.110452,93 C63.1374828,93 66.358563,89.4875494 65.9678402,85.3124506 C65.626128,81.6727273 62.4132163,79 58.8150274,79 L39.6328553,79 C38.8718309,79 38.5764064,79.966996 39.1822309,80.4359684 C40.826806,81.7156126 41.8887006,83.7312253 41.8887006,86 C41.8887006,89.8666008 38.8051221,93 35,93 L59.110452,93 Z",
    id: "Fill-13",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.110452,93 C63.1374828,93 66.358563,89.4875494 65.9678402,85.3124506 C65.626128,81.6727273 62.4132163,79 58.8150274,79 L39.6328553,79 C38.8718309,79 38.5764064,79.966996 39.1822309,80.4359684 C40.826806,81.7156126 41.8887006,83.7312253 41.8887006,86 C41.8887006,89.8666008 38.8051221,93 35,93 L59.110452,93 Z",
    id: "Stroke-15",
    stroke: "#7450C8",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,52 L34,52",
    id: "Stroke-17",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,57 L34,57",
    id: "Stroke-19",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,62 L38,62",
    id: "Stroke-21",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,67 L40,67",
    id: "Stroke-23",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-25",
    fill: "#DFE4EE",
    points: "67.3849329 59 60 51.6157021 66.1534228 43 76 52.8457305"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7891845,53 L66,43.3368043 L93.675376,19.2409318 C95.6575628,17.5097668 98.6616222,17.6002411 100.533003,19.4475373 C102.433112,21.3218408 102.494671,24.3426022 100.675272,26.292526 L75.7891845,53 Z",
    id: "Fill-27",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0365459,68.1571318 C58.1469545,69.3437163 56.7521974,70.0542791 55.2700077,70.0750964 C52.9356978,70.1070162 49.3287587,70.4373169 47,72 C48.5599075,69.6545875 48.891596,66.0573631 48.9249036,63.7286045 C48.9457209,62.245027 49.6548959,60.8544333 50.8414803,59.9634541 L58.7922899,54 L65,60.2063223 L59.0365459,68.1571318 Z",
    id: "Fill-29",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-31",
    fill: "#FFFFFF",
    points: "64.0004472 61 58 54.9995528 59.8016098 52 67 59.1997317"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-33",
    stroke: "#7450C8",
    strokeLinejoin: "round",
    points: "64.0004472 61 58 54.9995528 59.8016098 52 67 59.1997317"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0365459,68.1571318 C58.1469545,69.3437163 56.7521974,70.0542791 55.2700077,70.0750964 C52.9356978,70.1070162 49.3287587,70.4373169 47,72 C48.5599075,69.6545875 48.891596,66.0573631 48.9249036,63.7286045 C48.9457209,62.245027 49.6548959,60.8544333 50.8414803,59.9634541 L58.7922899,54 L65,60.2063223 L59.0365459,68.1571318 Z",
    id: "Stroke-35",
    stroke: "#7450C8",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-37",
    stroke: "#7450C8",
    strokeLinejoin: "round",
    points: "67.3849329 59 60 51.6157021 66.1534228 43 76 52.8457305"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5606719,65.5606719 C54.9749012,66.1464427 54.0250988,66.1464427 53.4393281,65.5606719 C52.8535573,64.9749012 52.8535573,64.0250988 53.4393281,63.4393281 C54.0250988,62.8535573 54.9749012,62.8535573 55.5606719,63.4393281 C56.1464427,64.0250988 56.1464427,64.9749012 55.5606719,65.5606719",
    id: "Fill-39",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5606719,65.5606719 C54.9749012,66.1464427 54.0250988,66.1464427 53.4393281,65.5606719 C52.8535573,64.9749012 52.8535573,64.0250988 53.4393281,63.4393281 C54.0250988,62.8535573 54.9749012,62.8535573 55.5606719,63.4393281 C56.1464427,64.0250988 56.1464427,64.9749012 55.5606719,65.5606719 Z",
    id: "Stroke-41",
    stroke: "#7450C8",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,66 L47,72",
    id: "Stroke-43",
    stroke: "#7450C8",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9765129,28 L100.031651,29.0727898 C101.281364,30.3420806 101.327069,32.3867541 100.136121,33.7131365 L90,45",
    id: "Stroke-45",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-47",
    fill: "#FFFFFF",
    points: "68.5718151 41 66 43.2769161 75.6811725 53 78 50.467678"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-49",
    stroke: "#7450C8",
    strokeLinejoin: "round",
    points: "68.5718151 41 66 43.2769161 75.6811725 53 78 50.467678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7891845,53 L66,43.3368043 L93.675376,19.2409318 C95.6575628,17.5097668 98.6616222,17.6002411 100.533003,19.4475373 C102.433112,21.3218408 102.494671,24.3426022 100.675272,26.292526 L75.7891845,53 Z",
    id: "Stroke-51",
    stroke: "#7450C8",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/Document.eeb08ec4f74b651045a9182e399d9fd1.svg";
export { ForwardRef as ReactComponent };